import {
  Box,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Text,
  PopoverProps,
  PopoverContentProps
} from '@chakra-ui/react'
import { HintElementProps } from 'components/utils/interfaces'
import React, { ReactNode } from 'react'
import { FaInfoCircle } from 'react-icons/fa'

interface CustomPopoverProps extends Partial<PopoverProps>, HintElementProps {
  children?: ReactNode
  customTrigger?: ReactNode
  canClose?: boolean
  label?: string
  contentProps?: PopoverContentProps
}
const CustomPopover: React.FC<CustomPopoverProps> = ({
  children,
  customTrigger,
  label = 'More Information',
  icon: Icon = FaInfoCircle,
  iconColor = 'rgba(0,0,0,0.5)',
  textColor = 'rgba(0,0,0,0.5)',
  fontSize = 'sm',
  spacing = 3,
  placement = 'bottom',
  canClose = true,
  contentProps,
  ...popoverProps
}) => {
  return (
    <Popover {...popoverProps} placement={placement}>
      <PopoverTrigger>
        {customTrigger ? (
          customTrigger
        ) : (
          <Flex direction="row" align="center" mt={6}>
            <Box color={iconColor} as={Icon} mr={spacing} />
            <Text color={textColor} fontSize={fontSize}>
              {label}
            </Text>
          </Flex>
        )}
      </PopoverTrigger>
      <PopoverContent as="div" borderColor="gray.100" fontSize="sm" zIndex={40} {...contentProps}>
        <PopoverArrow />
        {canClose && <PopoverCloseButton />}
        <PopoverBody>{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  )
}

export default CustomPopover
